import apiClient from "./api";
const COTIZACION_API_BASE_URL = "/cotizaciones";
class CotizacionesService {
  getCotizaciones() {
    return apiClient.get(COTIZACION_API_BASE_URL);
  }

  agregarCotizacion(cotizacion) {
    return apiClient.post(COTIZACION_API_BASE_URL, cotizacion);
  }
  updateCotizacion(cotizacion, cotizacionId) {
    return apiClient.put(COTIZACION_API_BASE_URL + "/" + cotizacionId, cotizacion);
  }
updateCodigoCotizacion(cotizacion, cotizacionId) {
    return apiClient.put(COTIZACION_API_BASE_URL + "/codigo/" + cotizacionId, cotizacion);
  }

  async buscarCotizacionesNF(busqueda) {
    try {
      const response = await apiClient.post(
        `${COTIZACION_API_BASE_URL}/buscar/nf`,
        { busqueda },
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async buscarCotizacionesSucursal(id) {
    try {
      const response = await apiClient.get(
        `${COTIZACION_API_BASE_URL}/buscar/sucursal/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getCotizacionIndividual(cotizacionId) {
    try {
      const response = await apiClient.get(
        `${COTIZACION_API_BASE_URL}/${cotizacionId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

}
export default new CotizacionesService();
